import React, { useEffect, useState } from "react";
// import { Category } from "./ResourceGrid";
import { Dropdown } from "../Dropdown/Dropdown";
import { Chip } from "../Chip/Chip";
import { title } from "process";

export interface FilterOption {
  title: string;
  id: string;
  category?: FilterOption
}

interface BlogFiltersProps {
  gridFilters?: any;
  selectedFilters: FilterOption[] | [];
  selectedSorting: FilterOption[];
  sortingOptions: string[];
  labelSortBy?: string;
  labelClearAll?: string;
  handleFilterChange: Function;
  handleSortingChange: (selected: FilterOption[]) => void;
  handleChipDelete: (filter: FilterOption) => void;
  setSelectedSorting: Function;
}

const BlogFilters = ({
  gridFilters,
  selectedFilters,
  selectedSorting,
  sortingOptions,
  labelSortBy = "Sort By",
  labelClearAll = "Clear All",
  handleChipDelete,
  handleFilterChange,
  handleSortingChange,
  setSelectedSorting
}: BlogFiltersProps) => {

  return (
    <div className="rc-resource-grid__blog__filters">
      <div className="rc-resource-grid__blog__filters__dropdown">
        {gridFilters?.filterTags?.map((filter: any, i: number) => {
          return (
            <Dropdown
              key={`${filter?.title}`}
              options={filter?.dropdownValues?.map((value: any) => ({
                id: value.id, // Use label as value
                title: value.label,
                category: { title: filter?.title, id: filter?.id }
              }))}
              title={filter?.title}
              selectedFilters={selectedFilters}
              onChange={handleFilterChange}
              multiSelect={true}
              labelClearAll={labelClearAll}
            />
          )
        })}
        <Dropdown
          key={`sort`}
          options={sortingOptions?.map((opt) => ({
            id: opt,
            title: opt,
          }))}
          onChange={handleSortingChange}
          selectedFilters={selectedSorting}
          title={labelSortBy}
          multiSelect={false}
        />
      </div>
      <div className="rc-resource-grid__blog__filters__chips">
        {selectedFilters && selectedFilters?.map((filter: FilterOption, i: number) => {
          return <Chip
            key={`${filter?.id}-${i}`}
            label={filter?.title}
            isIcon
            onDelete={() => handleChipDelete(filter)}
          />
        })}
      </div>
    </div>
  );
};

export default BlogFilters;
